import { Carousel, AnalyticsAttributesProvider } from "../../components";
import { UiCarouselModel } from "../../models";
import { renderViewModel } from "../../render-view-model";
import { MapModelToProps } from "../../utils";

import { ShadowWrapper } from "./UiCarousel.styles";

export type UiCarouselProps = MapModelToProps<UiCarouselModel>;

const UiCarousel = ({ model }: UiCarouselProps) => {
    const {
        blocks,
        arrows = true,
        dots,
        title,
        dotLabel,
        prevArrowLabel,
        nextArrowLabel
    } = model.content;
    return (
        <AnalyticsAttributesProvider
            value={{ eventColumn: title, eventComponent: model.type }}
        >
            <Carousel
                arrows={arrows}
                dotsOnDesktop={dots}
                dotsOnMobile={true}
                dotLabel={dotLabel}
                prevArrowLabel={prevArrowLabel}
                nextArrowLabel={nextArrowLabel}
            >
                {blocks?.map((block) =>
                    //so shadows won't be hidden by carousel's overflow-hidden
                    block.type === "uiBlock" && block.content.shadow ? (
                        <ShadowWrapper key={block.id}>
                            {renderViewModel(block)}
                        </ShadowWrapper>
                    ) : (
                        renderViewModel(block)
                    )
                )}
            </Carousel>
        </AnalyticsAttributesProvider>
    );
};

export default UiCarousel;
